import { FC, useEffect, useRef } from "react";

import { useElements } from "@stripe/react-stripe-js";

import { useTranslate } from "@/common/hooks/useTranslate";
import { FormInfobox } from "@/forms-design-system/FormInfobox";
import { Info } from "@/icons/outlined";

export const BankConnectionGuidance: FC = () => {
  const { t } = useTranslate();
  const elements = useElements();
  const containerRef = useRef<HTMLDivElement>(null);

  // The donor clicked the submit button far below the payment element: bring the bank option back into view.
  useEffect(() => {
    containerRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    elements?.getElement("payment")?.focus();
  }, [elements]);

  return (
    <FormInfobox
      ref={containerRef}
      icon={<Info />}
      variant="emphasis"
      description={t("common", "payment.bank.connectGuidance")}
      data-test="bank-connection-guidance"
    />
  );
};
